import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useBrandStore } from './stores/brandStore'
import './assets/css/main.css'

const app = createApp(App)

app.use(createPinia())

// Brand must be known before any view renders: it drives theme, copy and product ids.
useBrandStore().resolveBrandFromHost()

app.use(router)

app.mount('#app')
